import React from "react"
import { Grid, GridItem, Hide } from "@chakra-ui/react";
import APIconButton from "./APIconButton";
import NavMenu from "./NavMenu";

const NavTopBar = (
  {
    backIcon,
    handleBack,
    backAriaLabel,
    backTabIndex,
    title,
  }: {
    backIcon: React.ReactElement
    handleBack: () => void
    backAriaLabel?: string
    backTabIndex?: number
    title: React.ReactElement
    openProfile: () => void
    openSettings: () => void
  }
) => {

  return (
    <Grid templateColumns={"20% 60% 20%"} fontSize={"xl"}
          layerStyle={"pageHeader"} width={"100%"}>
      <GridItem>
        <APIconButton
          variant={"raisedIcon"}
          colorScheme={"secondary"}
          onClick={handleBack}
          aria-label={backAriaLabel}
          tabIndex={backTabIndex}>
          {backIcon}
        </APIconButton>
      </GridItem>
      <GridItem>
        <Hide below={"lg"}>
          {title}
        </Hide>
      </GridItem>
      <GridItem>
        <NavMenu />
      </GridItem>
    </Grid>
  )
}

export default NavTopBar